module.exports = __webpack_public_path__ + "static/media/onda-small.9d7c127c.svg";